import axios from "axios";

export default function PurchaseorderDeliverynoteCreateService(formData, orderId) {
  return axios({
    method: 'post',
    url: process.env.REACT_APP_API_HOST + "/purchase_order/" + orderId + "/delivery_note",
    data: formData,
    params: {},
    headers: {'Authorization': 'Bearer ' + localStorage.getItem("userToken"), 'App-Network': localStorage.getItem("networkId")}
  });
}
